<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <error-404 v-if="notfound" ></error-404>
    <router-view v-else @setAppClasses="setAppClasses" />
    <cookies></cookies>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import error404 from '@/views/pages/Error404'
import Cookies from '@/components/Cookies'
import { mapMutations } from 'vuex'

export default {
  components: {
      error404,
      Cookies
  },
  data () {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    loading (val) {
        if (val) {
            this.$vs.loading({
                container: this.$refs.content,
                color:'rgb(var(--vs-secondary))',
                type: 'point',
                scale: 1,
            });
        } else {
            this.$vs.loading.close();
        }
    },
    showNotifications (val) {
        if (val) {
            const aux = this;
            const notifications = JSON.parse(localStorage.getItem('notifications'));
            if (notifications) {
                notifications.forEach(function (notification) {
                  notification.title = aux.$t(notification.title);
                  notification.text = aux.$t(notification.text);
                  aux.$vs.notify(notification);
                });
            }
            this.$store.commit('notificationsRemove');
            this.$store.commit('showNotifications', false);
        }
    },
  },
  computed: {
      loading ()     { return this.$store.state.loading },
      notfound ()     { return this.$store.state.notfound },
      showNotifications ()     { return this.$store.state.showNotifications },
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        // eslint-disable-next-line sonarjs/no-duplicate-string
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    ...mapMutations({
      recoverUser: 'recoverUser',
      recoverLanguages: 'recoverLanguages',
      recoverCurrentLanguage: 'recoverCurrentLanguage',
      setCurrentLanguage: 'setCurrentLanguage',
    })
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
    this.recoverUser();
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
